import { useEffect } from 'react';
import { ToastContainer as BSToastContainer } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { selectToast } from 'redux/app/app.selector';
import Toast from './Toast';
import { hideToast } from 'util/utils';
import './ToastContainer.scss';

const ToastContainer = () => {
  const toast = useSelector(selectToast);

  useEffect(() => {
		Object.keys(toast).map((id) =>{
			const hideToasts = () => {
				hideToast()
			};
			const timerId = setTimeout(hideToasts, 6000);
			return () => {
				clearTimeout(timerId);
			};
		});
	}, [toast]);

  return (
    <BSToastContainer>
      {Object.keys(toast).map((id) => (
        <Toast key={id} {...{ ...toast[id], id }} />
      ))}
    </BSToastContainer>
  );
};

export default ToastContainer;
